/* eslint-disable no-console */
import wrapper from 'wrapper';
import Lookup from './components/country-lookup/country-lookup';

const countryData = wrapper.getConfig().app.data;
const lookupContainer = wrapper.select('#lookup-container');

const lookup = new Lookup(countryData, lookupContainer);
lookup.init();

wrapper.select('.newsspec-29591-app').classList.remove('no-js');

wrapper.markPageAsLoaded();
